export default __webpack_public_path__ + "static/sanjayRakesh8-71caa5701baddec62b31db6c9b5f21ee.jpg";